import { render } from "./FormEditor.vue?vue&type=template&id=0857e27a&scoped=true"
import script from "./FormEditor.vue?vue&type=script&lang=js"
export * from "./FormEditor.vue?vue&type=script&lang=js"

import "./FormEditor.vue?vue&type=style&index=0&id=0857e27a&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0857e27a"]])

export default __exports__
import QEditor from 'quasar/src/components/editor/QEditor.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QEditor});
